module.exports = __webpack_public_path__ + "img/no.73175b1d.gif";